import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=7650afce&lang=pug&"
import script from "./Pending.vue?vue&type=script&lang=ts&"
export * from "./Pending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pending.vue"
export default component.exports